import { FormikHelpers } from "formik";
import ModelForm from "./ModelForm";
import { useGetModel } from "./api/getModel";
import { useEditModel } from "./api/editModel";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditModel = ({handleCloseModal, modelId}: EditModelProps)  => {
  const getModelQuery = useGetModel({modelId: modelId})
  const editModelMutation = useEditModel({data: {}, modelId});

  const initialValues: IEditModelForm = {
    description: getModelQuery.data?.description,
    deleted: getModelQuery.data?.deleted,
    modelTypeID: getModelQuery.data ? getModelQuery.data.modelTypeID.toString() : "",
    module: getModelQuery.data?.module
  }

  const handleSubmit = async (values: IEditModelForm, { setSubmitting }: FormikHelpers<IEditModelForm>): Promise<void> => {
    try {
      await editModelMutation.mutateAsync({
        data: values,
        modelId: modelId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getModelQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getModelQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Τύπου Συσκευής.</div>
    )
  }

  return (
    <>
      {!getModelQuery.isLoading && getModelQuery.data &&
        <ModelForm initialValues={initialValues} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditModelProps {
  modelId: number;
  handleCloseModal: () => void;
}

export default EditModel;